import keycode from 'keycode';
import {noop} from 'lodash';

export class InputKeySelectorCustomAttribute {
  // TODO:
}

export class InputKeySelector {

  __onUp: (e: KeyboardEvent) => void;
  __onDown: (e: KeyboardEvent) => void;
  __onSelect: (e: KeyboardEvent) => void;

  constructor({
                onSelect = noop,
                onUp = noop,
                onDown = noop
              }) {
    this.__onUp = onUp;
    this.__onDown = onDown;
    this.__onSelect = onSelect;
  }

  handleKeyPress(event) {
    switch (event.keyCode || event.which) {
    case keycode.codes.enter:
    case keycode.aliases.return:
      this.__onSelect(event);
      break;
    case keycode.codes.up:
      this.__onUp(event);
      break;
    case keycode.codes.down:
      this.__onDown(event);
      break;
    default: // do nothing
    }
  }

}
